<template>
  <div class="edit-roles">
    <div class="breadcrumb" style="background: #fff">角色设置</div>
    <el-form :model="roleList" :rules="rules" ref="formRefs">
      <el-form-item label="角色名称:" label-width="100px" prop="name">
        <span v-if="$route.query.set === 'edit'">{{ roleList.name }}</span>
        <el-input v-if="$route.query.set === 'add'" v-model="roleList.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="角色编码:" label-width="100px" prop="code">
        <span v-if="$route.query.set === 'edit'">{{ roleList.code }}</span>
        <!-- <el-input  v-if="$route.query.set==='add'" v-model="roleList.code"></el-input> -->
        <!-- onkeypress='return( /[^[A-Z]]/.test(String.fromCharCode(event.keyCode)))' -->
        <el-input placeholder="大写字母或下划线" v-if="$route.query.set === 'add'" v-model="roleList.code" clearable>
          <template slot="prepend">ROLE_</template>
        </el-input>
      </el-form-item>
      <el-form-item label="角色描述:" label-width="100px">
        <el-input v-model="roleList.remark" clearable></el-input>
      </el-form-item>
      <el-form-item label="权限设置:" label-width="100px">
        <el-tree :data="limits" show-checkbox node-key="id" ref="tree" check-strictly :default-expanded-keys="[40022]" @check-change="click" @check='check' :default-checked-keys="isSelectMenuList"
          :props="defaultProps">
        </el-tree>
      </el-form-item>
    </el-form>
    <div class="save-role">
      <el-button round type="primary" @click="saveRoles">保存</el-button>
    </div>
  </div>
</template>
<script>
import { getRoleById, getMenuByRole, getAllMenu, roleSave, roleUpdate } from '@/api/crm'
import { stringify } from 'qs'
export default {
  name: 'edit-roles',
  data () {
    var checkCode = (rule, value, callback) => {
      let reg = /^[A-Z_]+$/
      if (this.$route.query.set === 'add') {
        if (reg.test(this.roleList.code)) {
          callback()
        } else {
          callback(new Error('只能输入大写字母或下划线'))
        }
      } else {
        callback()
      }
    }
    return {
      lock: true,
      roleList: {
        menuIds: ['1', '2']
      },
      rules: {
        code: [
          { required: true, validator: checkCode, trigger: 'blur' }
        ],
        name: [
          {
            required: true,
            message: '请输入角色名称',
            trigger: 'blur'
          }, {
            min: 0,
            max: 20,
            message: '最多输入20个字符'
          }],
        remark: [{
          min: 0,
          max: 50,
          message: '最多输入50个字符'
        }]
      },
      limits: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        disabled: 'disabled'
      },
      isSelectMenuList: [],
      justOne: []
    }
  },
  created () {
    if (this.$route.query.set === 'edit') {
      getRoleById(this.$route.query.id).then((res) => {
        if (res.data.success) {
          let obj = {}
          obj.code = res.data.data.code
          obj.id = res.data.data.id
          obj.menuIds = res.data.data.menuIds
          obj.name = res.data.data.name
          obj.remark = res.data.data.remark
          obj.status = res.data.data.status
          this.roleList = obj
          this.roleList.menuIds = []
          this.getList(res.data.data.id)
        } else {
        }
      })
    } else if (this.$route.query.set === 'add') {
      getAllMenu().then(res => {
        if (res.data.success) {
          this.limits = this.disposeData(res.data.data)
          console.log(this.limits)
        }
      })
    }
  },
  methods: {
    input (val) {
      val = val.replace(/^[A-Z]+$/, '')
    },
    click (item, a, b) {
      if (item.id === 10007 || item.id === 10008 || item.id === 10009 || item.id === 460071 || item.id === 1300207 || item.id === 1300247) {
        a ? this.justOne.push(item.id) : this.justOne.splice(this.justOne.indexOf(item.id), 1)
      }
      // if (this.justOne[item.id] !== undefined) {
      //     if (!a) {
      //       this.justOne[item.id] = a
      //       return false
      //     }
      //     for (let ele in this.justOne) {
      //       if (ele === item.id) continue
      //       if (this.justOne[ele]) {
      //         this.$message({ message: '登陆权限只能选一个', type: 'error' })
      //         this.$refs.tree.setChecked(item.id, false)
      //         break
      //       }
      //     }
      //     this.justOne[item.id] = a
      // }
    },
    check (data) {
      let node = this.$refs.tree.getNode(data)
      this.childNodes(node)
      this.parentNodes(node)
    },
    childNodes (node) {
      let len = node.childNodes.length
      for (let i = 0; i < len; i++) {
        node.childNodes[i].checked = node.checked
        this.childNodes(node.childNodes[i])
      }
    },
    parentNodes (node) {
      if (node.parent) {
        for (let key in node) {
          if (key === 'parent') {
            node[key].checked = true
            this.parentNodes(node[key])
          }
        }
      }
    },
    disposeData (data) {
      let obj = []
      data.forEach(item => {
        let obj2 = {}
        obj2.id = item.id
        obj2.label = item.name
        obj2.children = this.disposeData(item.children)
        if (item.name === '登录权限') {
          obj2.disabled = true
          item.children.forEach(i => {
            i.isSelect && (this.justOne.push(i.id))
          })
        }
        if (item.isSelect) this.isSelectMenuList.push(item.id)
        obj.push(obj2)
      })
      return obj
    },
    getList (id) {
      getMenuByRole(id).then((res) => {
        if (res.data.success) {
          this.limits = this.disposeData(res.data.data)
          console.log(this.justOne)
        } else {
        }
      })
    },
    setCheckedKeys () {
      this.$refs.tree.setCheckedKeys([10001])
    },
    saveRoles () {
      if (!this.lock) {
        this.$message.warning('正在处理，请稍后')
        return
      }
      if (this.justOne.length === 0) {
        this.$message.error('登陆权限至少选一个')
        return
      }
      this.roleList.menuIds = [...this.$refs.tree.getCheckedKeys(), ...this.$refs.tree.getHalfCheckedKeys()]
      this.$refs.formRefs.validate((valid) => {
        if (valid) {
          this.lock = false
          this.saveVo = JSON.parse(JSON.stringify(this.roleList))
          this.saveVo.code = 'ROLE_' + this.roleList.code

          if (this.$route.query.set === 'add') {
            this.saveVo.attachType = 'HQ'
            console.log(this.saveVo)
            roleSave(this.saveVo).then((res) => {
              this.lock = true
              if (res.data.success) {
                this.$message.success('操作成功')
                this.$router.push('./rolemanage')
              } else {
              }
            })
          } else if (this.$route.query.set === 'edit') {
            roleUpdate(this.saveVo).then((res) => {
              this.lock = true
              if (res.data.success) {
                this.$message.success('操作成功')
                this.$store.dispatch('user/getList', '/rolemanage')
              } else {
              }
            })
          } else {
            return false
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.edit-roles {
  background: #fff;

  .el-form {
    padding: 20px 0;
    width: 500px;

    .el-input {
      width: 500px !important;
    }

    .el-tree {
      height: 400px;
      width: 500px;
      overflow-y: scroll;
      border: 1px solid #ececec;
    }
  }

  .save-role {
    display: flex;
    justify-content: flex-end;
    background: #f7f7f7;
    padding: 20px;

    .el-button {
      width: 100px;
      margin-right: 50px;
    }
  }
}
</style>
